<script>
export default {
    name: 'IconArrowDown',
}
</script>
<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
        class="base-icon icon-arrow-down"
    >
        <g clip-path="url(#a)">
            <path 
                fill="currentColor"  
                fill-rule="evenodd" 
                d="M64 32.04 32.133 64 32 63.867l-.133.133L0 32.04l5.624-5.64 22.4 22.464V0h7.952l.001 48.864 22.4-22.465L64 32.04Z" 
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h64v64H0z"/>
            </clipPath>
        </defs>
    </svg>
</template>
